import { MeasurementProtocolData } from "@/data/models/MeasurementProtocolData";
import { getProjectRef } from "./ProjectRepository";
import { db } from "@/main";

export function observeMeasurementProtocolData(
  projectId: string,
  onNext: (reports: Array<MeasurementProtocolData>) => void
) {
  return db
    .doc(getProjectRef(projectId))
    .collection("measurementProtocol")
    .onSnapshot((snapshot) =>
      onNext(
        snapshot.docs.map((doc) => {
          const data = doc.data();

          return data as MeasurementProtocolData;
        })
      )
    );
}
